import { create } from "zustand";

// Persiste i filtri della pagina Ricevute tra le navigazioni (es. apri il dettaglio
// di una ricevuta e torni indietro → i filtri restano impostati). Vive fuori dal
// ciclo di vita della pagina, quindi sopravvive allo smontaggio del componente.
export interface ReceiptsFilters {
  socioFilter: string;
  year: string;
  mode: string;
  activeFilter: string;
  typeFilter: string;
}

interface ReceiptsFilterState extends ReceiptsFilters {
  set: (patch: Partial<ReceiptsFilters>) => void;
}

export const useReceiptsFilterStore = create<ReceiptsFilterState>((set) => ({
  socioFilter: "",
  year: "",
  mode: "",
  activeFilter: "",
  typeFilter: "",
  set: (patch) => set(patch)
}));
